export default __webpack_public_path__ + "static/media/HN_Resume.e606fa9b.pdf";